import * as THREE from 'three/webgpu';

class CloudShadowLightingModel extends THREE.PhysicalLightingModel {

	constructor( shadowNode ) {

		super();
		this.shadowNode = shadowNode;

	}

	direct( { lightDirection, lightColor, reflectedLight }, builder ) {

		super.direct( {
			lightDirection,
			lightColor: lightColor.mul( this.shadowNode ),
			reflectedLight
		}, builder );

	}

}

class CloudShadowTerrainMaterial extends THREE.MeshStandardNodeMaterial {

	constructor( shadowNode, parameters ) {

		super( parameters );
		this.cloudShadowNode = shadowNode;

	}

	setupLightingModel() {

		return new CloudShadowLightingModel( this.cloudShadowNode );

	}

}

export function createWorld( cloudShadows = null ) {

	const group = new THREE.Group();
	group.name = 'Scale reference world';

	const groundMaterial = cloudShadows
		? new CloudShadowTerrainMaterial( cloudShadows.createTerrainShadowNode(), { color: 0x244547, roughness: 0.92, metalness: 0 } )
		: new THREE.MeshStandardMaterial( { color: 0x244547, roughness: 0.92, metalness: 0 } );
	// Keep the ground wider than the camera's far plane and recenter it as the
	// viewer flies. This makes the atmospheric horizon, rather than mesh edges,
	// terminate the terrain without requiring enormous world coordinates.
	const ground = new THREE.Mesh( new THREE.PlaneGeometry( 16000, 16000 ), groundMaterial );
	ground.name = 'Horizon-following ground';
	ground.rotation.x = - Math.PI * 0.5;
	ground.position.y = - 1;
	group.add( ground );

	const ridgeMaterial = new THREE.MeshStandardMaterial( {
		color: 0x34585a,
		roughness: 0.88,
		metalness: 0
	} );
	const ridgeData = [
		[ - 440, - 360, 280, 72, 0.45 ],
		[ - 90, - 560, 390, 126, 0.34 ],
		[ 350, - 470, 320, 92, 0.4 ],
		[ 610, - 120, 240, 65, 0.38 ],
		[ - 650, 20, 220, 54, 0.42 ]
	];

	for ( const [ x, z, width, height, depthScale ] of ridgeData ) {

		const ridge = new THREE.Mesh( new THREE.SphereGeometry( 1, 28, 12 ), ridgeMaterial );
		ridge.position.set( x, - height * 0.08, z );
		ridge.scale.set( width, height, width * depthScale );
		group.add( ridge );

	}

	group.updateForCamera = ( camera ) => {

		ground.position.x = camera.position.x;
		ground.position.z = camera.position.z;

	};

	return group;

}
